import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthRoutes } from '@bn/auth/enums';
import { Auth2faGuard } from '@bn/auth/guards/auth-2fa.guard';

import { AuthLayoutComponent } from './layout/auth-layout.component';
import { EmailConfirmedPage, LoginPage, RegisterPage, ResetPasswordPage, TwoFactorAuthPage } from './pages';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: AuthRoutes.Login, component: LoginPage },
      { path: AuthRoutes.ResetPassword, component: ResetPasswordPage },
      {
        path: AuthRoutes.Register,
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: RegisterPage,
          },
          {
            path: ':tenantId',
            component: RegisterPage,
          },
        ],
      },
      { path: AuthRoutes.TwoFactorAuth, canActivate: [Auth2faGuard], component: TwoFactorAuthPage },
      { path: AuthRoutes.EmailConfirmed, component: EmailConfirmedPage },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
